import EmailAvailabilityStatus from '@vendor/js/enums/EmailAvailabilityStatus';
import { Api } from '@vendor/js/api';
import { Spinner } from '@vendor/js/spinner';
import Common from '@vendor/js/common';
import { i18n } from '@vendor/libs/lang/lang';
import Swal from 'sweetalert2';
const _UsersCommonHandler = (function () {
    let emailIsBusy = false;
    let previousEmailAddress = null;
    let successfulCommonDataFetch = false;
    return {
        // Public functions
        init: function () { },
        /**
         * Retrieves the availability status of an email address from the server.
         *
         * @async
         * @param {string} email - The email address to check.
         * @param {number} [entityId] - Optional entity ID.
         * @returns {Promise<EmailAvailabilityStatus>} - A promise that resolves to the availability status of the email address.
         */
        getEmailAddressAvailabilityStatus: async (email, entityId) => {
            const response = await Api.get(`/users/availability/email?email=${email}${entityId ? `&entity_id=${entityId}` : ''}`);
            return EmailAvailabilityStatus.getByValue(response.data.status);
        },
        fillCommonUserFormInputsByEmailAddress: async (form, email, phoneNumber) => {
            try {
                const response = await Api.get(`/users/common-data?email=${email}${phoneNumber ? `&phone_number=${phoneNumber}` : ''}`);
                // fill form inputs
                for (const name in response.data.user) {
                    Common.fillFormElement(form, name, response.data.user[name]);
                }
                if (response.data.user.awards && response.data.user.awards.length) {
                    Common.fillFormElement(form, 'award[*]', false);
                    for (const award of response.data.user.awards) {
                        Common.fillFormElement(form, `award[${award.id}]`, true);
                    }
                }
                // hide email error
                Common.clearFormInputError(form, 'email');
                // make password non-required
                Common.changeFormInputRequirement(form, 'password', false);
                Common.setFormInputHelpText(form, 'password', i18n.trans('models/members.pages.edit.password_help'));
                successfulCommonDataFetch = true;
                return true;
            }
            catch (err) { }
            successfulCommonDataFetch = false;
            return false;
        },
        /**
         * Sets up an email address availability check on a target input element.
         *
         * @param {string} targetInputSelector - The selector of the target input element.
         * @param {number} entityId - The ID of the entity to check the email address against.
         * @param {boolean} confirmPhoneNumberIfBusy - Whether to confirm the phone number if the email address is busy. Defaults to false.
         * @param {Object} options - Additional options.
         * @param {string} options.alreadyInEntityText - The text to display when the email address is already associated with another entity.
         *
         * @returns {void}
         */
        setupEmailAddressAvailabilityCheck: (targetInputSelector, entityId, confirmPhoneNumberIfBusy = false, { alreadyInEntityText } = {}) => {
            $(targetInputSelector).on('blur', async function () {
                const email = $(this).val();
                const form = $(this).closest('form');
                if (email == previousEmailAddress && successfulCommonDataFetch) {
                    return;
                }
                previousEmailAddress = email;
                emailIsBusy = false;
                Common.changeFormInputRequirement(form, 'password', true);
                Common.setFormInputHelpText(form, 'password', null);
                const spinner = new Spinner();
                try {
                    const emailAvailabilityStatus = await _UsersCommonHandler.getEmailAddressAvailabilityStatus(email, entityId);
                    if (emailAvailabilityStatus == EmailAvailabilityStatus.ALREADY_IN_ENTITY) {
                        Common.addFormInputError(form, 'email', i18n.trans(alreadyInEntityText ??
                            'models/members.pages.common.email_availability.already_in_entity'));
                        return;
                    }
                    if (emailAvailabilityStatus == EmailAvailabilityStatus.BUSY) {
                        Common.addFormInputError($(this).closest('form'), 'email', i18n.trans('models/members.pages.common.email_availability.busy'));
                        return;
                    }
                    if (emailAvailabilityStatus == EmailAvailabilityStatus.IN_OTHER_ENTITY) {
                        emailIsBusy = true;
                        if (confirmPhoneNumberIfBusy) {
                            Swal.fire({
                                title: i18n.trans('models/members.pages.common.phone_number_confirmation.confirm_title'),
                                text: i18n.trans('models/members.pages.common.phone_number_confirmation.confirm_text'),
                                input: 'text',
                                buttonsStyling: false,
                                reverseButtons: true,
                                confirmButtonText: i18n.trans('common.confirm'),
                                cancelButtonText: i18n.trans('common.cancel'),
                                customClass: {
                                    confirmButton: 'btn btn-primary',
                                    cancelButton: 'btn btn-secondary me-2',
                                },
                                inputAttributes: {
                                    autocapitalize: 'off',
                                },
                                inputValue: form.find('[name="phone_number"]').val(),
                                showCancelButton: true,
                                showLoaderOnConfirm: true,
                                allowOutsideClick: () => false,
                                async preConfirm(inputValue) {
                                    const success = await _UsersCommonHandler.fillCommonUserFormInputsByEmailAddress(form, email, inputValue);
                                    if (!success) {
                                        return Swal.showValidationMessage('Podano nieprawidłowy numer telefonu');
                                    }
                                },
                            }).then((result) => {
                                if (!result.isConfirmed) {
                                    Common.addFormInputError(form, 'email', i18n.trans('models/members.pages.common.email_availability.busy'));
                                }
                            });
                            return;
                        }
                        await _UsersCommonHandler.fillCommonUserFormInputsByEmailAddress(form, email);
                    }
                }
                catch (err) {
                }
                finally {
                    spinner.destroy();
                }
            });
            _UsersCommonHandler.setupPhoneNumberConfirmation('[name="phone_number"]');
        },
        setupPhoneNumberConfirmation: (targetInputSelector) => {
            $(targetInputSelector).on('blur', function () {
                const form = $(this).closest('form');
                const emailInput = form.find('[name="email"]');
                if (emailInput.val() && emailIsBusy && !successfulCommonDataFetch) {
                    _UsersCommonHandler.fillCommonUserFormInputsByEmailAddress(form, emailInput.val(), $(this).val());
                }
            });
        },
    };
})();
window.UsersCommonHandler = _UsersCommonHandler;
